module.exports = __webpack_public_path__ + "static/media/090.648d403c.jpg";